/**
 * main.jsx — Application entry point
 *
 * Bootstraps the React app and renders the root component.
 * MSAL provider wraps the entire app to make auth context
 * available to all child components.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
